// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__xlkFx","control":"Checkbox_control__gmMY5","fake":"Checkbox_fake__zZXzR utils_circle__nPDAm"};